import { motion } from 'motion/react'
import { EASE } from './motion'

interface SplitTextProps {
  text: string
  className?: string
  delay?: number
  stagger?: number
}

// Each word rises out of its own clipping mask -- the classic editorial
// headline reveal.
export function SplitText({ text, className = '', delay = 0, stagger = 0.08 }: SplitTextProps) {
  return (
    <span aria-label={text}>
      {text.split(' ').map((word, i) => (
        <span
          key={i}
          aria-hidden
          className="mr-[0.22em] inline-block overflow-hidden pb-[0.14em] pr-[0.06em] align-bottom -mb-[0.14em]"
        >
          <motion.span
            className={`inline-block ${className}`}
            initial={{ y: '120%', rotate: 5 }}
            animate={{ y: 0, rotate: 0 }}
            transition={{ duration: 1.1, delay: delay + i * stagger, ease: EASE }}
          >
            {word}
          </motion.span>
        </span>
      ))}
    </span>
  )
}
